import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import parse, { isValidPhoneNumber } from "libphonenumber-js";
import sortBy from "lodash/sortBy";
import { callingCodes, primaryCallingCodes, secondaryCallingCodes } from "./consts/CALLING_CODES";
export var ICountryCodeOption;
(function (ICountryCodeOption) {
  ICountryCodeOption.build = function (partial) {
    return _objectSpread({
      label: "",
      countryCallingCode: ""
    }, partial);
  };
})(ICountryCodeOption || (ICountryCodeOption = {}));
var getPhoneFormat = function getPhoneFormat(country) {
  switch (country) {
    case "United States of America":
    case "Canada":
      return "(###)-###-####";
    default:
      return undefined;
  }
};
var primaryOptions = function primaryOptions(strictLocalize) {
  return primaryCallingCodes(strictLocalize).concat(sortBy(secondaryCallingCodes(strictLocalize), "[0]")).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      label = _ref2[0],
      countryCallingCode = _ref2[1];
    return {
      label: label !== null && label !== void 0 ? label : "",
      countryCallingCode: countryCallingCode !== null && countryCallingCode !== void 0 ? countryCallingCode : "",
      format: getPhoneFormat(label !== null && label !== void 0 ? label : "")
    };
  });
};
var allOptions = function allOptions(strictLocalize) {
  return callingCodes(strictLocalize).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      label = _ref4[0],
      countryCallingCode = _ref4[1];
    return {
      label: label !== null && label !== void 0 ? label : "",
      countryCallingCode: countryCallingCode !== null && countryCallingCode !== void 0 ? countryCallingCode : ""
    };
  });
};
export var countryCallingCodeOptions = function countryCallingCodeOptions(strictLocalize) {
  return primaryOptions(strictLocalize).concat(sortBy(allOptions(strictLocalize), "label"));
};
export var validatePhoneNumber = function validatePhoneNumber(phoneNumber) {
  return phoneNumber ? isValidPhoneNumber(phoneNumber) : false;
};
export var parsePhoneNumber = function parsePhoneNumber(phoneNumber, countryCodeOption, strictLocalize) {
  var options = countryCallingCodeOptions(strictLocalize);
  // Special-case for empty/default input.
  if ((phoneNumber === null || phoneNumber === void 0 ? void 0 : phoneNumber.trim()) === "+1") {
    var _options$;
    return {
      countryCallingCodeOption: (_options$ = options[0]) !== null && _options$ !== void 0 ? _options$ : ICountryCodeOption.build(),
      // USA
      nationalPhoneNumber: ""
    };
  }
  var parsed = parse(phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : "");
  if (!(parsed !== null && parsed !== void 0 && parsed.isPossible())) {
    var _ref5, _ref6, _options$find, _ref7, _parsed$nationalNumbe;
    return {
      countryCallingCodeOption: (_ref5 = (_ref6 = (_options$find = options.find(function (c) {
        return c.countryCallingCode === "+".concat(parsed === null || parsed === void 0 ? void 0 : parsed.countryCallingCode);
      })) !== null && _options$find !== void 0 ? _options$find : countryCodeOption) !== null && _ref6 !== void 0 ? _ref6 : options[0]) !== null && _ref5 !== void 0 ? _ref5 : ICountryCodeOption.build(),
      // USA
      nationalPhoneNumber: (_ref7 = (_parsed$nationalNumbe = parsed === null || parsed === void 0 ? void 0 : parsed.nationalNumber) !== null && _parsed$nationalNumbe !== void 0 ? _parsed$nationalNumbe : phoneNumber) !== null && _ref7 !== void 0 ? _ref7 : ""
    };
  }
  var countryCallingCodeOption = options.find(function (option) {
    return "+".concat(parsed.countryCallingCode) === option.countryCallingCode;
  });
  if (!countryCallingCodeOption) {
    var _options$2;
    return {
      countryCallingCodeOption: (_options$2 = options[0]) !== null && _options$2 !== void 0 ? _options$2 : ICountryCodeOption.build(),
      // USA
      nationalPhoneNumber: parsed.nationalNumber
    };
  }
  return {
    countryCallingCodeOption: countryCallingCodeOption,
    nationalPhoneNumber: parsed.nationalNumber
  };
};